import React from 'react'

const Nav = () => {
    return (
        <div>
             <nav>
        <ul>
          <li>
            <a
              href="https://github.com/rahulbakshi4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-github"></i>
            </a>
          </li>
          <li>
            <a
              href="https://twitter.com/rahul_bakshi4"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-twitter"></i>
            </a>
          </li>
          <li>
            <a
              href="https://www.linkedin.com/in/rahul-bakshi-552071189/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <i className="fab fa-linkedin"></i>
            </a>
          </li>
        </ul>
      </nav>
        </div>
    )
}

export default Nav
